<template>
  <div class="register">
    <div class="register__card">
      <RegisterHeader>
        <template #title>
          <slot name="title" />
        </template>
        <template #description>
          <slot name="description" />
        </template>
      </RegisterHeader>
      <slot />
    </div>
  </div>
</template>

<script>
import RegisterHeader from '@/components/Auth/RegisterHeader'
export default {
  name: 'RegisterLayout',
  components: { RegisterHeader }
}
</script>

<style scoped lang="scss">
.register {
  padding: 96px 300px !important;

  &:before {
    position: absolute;
    content: '';
    background-image: url('/img/register-background.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    top: 0;
    right: 0;
    width: calc(100% - 120px);
    height: 100%;

    @include md-and-down {
      width: 100%;
    }
  }

  @include lg-and-down {
    padding: 96px 100px !important;
  }

  @include sm-and-down {
    padding: 88px 16px 48px !important;
  }

  &__card {
    background: $white url('/img/register-form-background.svg?v=12') no-repeat -24px -24px;
    box-shadow: 0 4px 20px rgba($mine-shaft, 0.05);
    border-radius: 16px;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: 100px 0 48px;
    position: relative;
    background-size: 112%;

    @include sm-and-down {
      padding: 85px 16px 24px;
    }
  }
}
</style>
